<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


(function () {
  if (window.__mmMegaHoverBound) return;
  window.__mmMegaHoverBound = true;

  const DESKTOP = window.matchMedia("(min-width: 1025px)");
  const CLOSE_DELAY = 90;
  const timers = new WeakMap();

  function clearCloseTimer(item) {
    const t = timers.get(item);
    if (t) {
      clearTimeout(t);
      timers.delete(item);
    }
  }

  function openItem(item) {
    clearCloseTimer(item);
    item.classList.add("mm-mega-open");
  }

  function scheduleClose(item) {
    clearCloseTimer(item);
    const t = setTimeout(() => {
      item.classList.remove("mm-mega-open");
      timers.delete(item);
    }, CLOSE_DELAY);
    timers.set(item, t);
  }

  function bindItem(item) {
    if (!item || item.dataset.mmMegaBound === "1") return;
    item.dataset.mmMegaBound = "1";

    const dropdown = item.querySelector(":scope > .menu-dropdown");
    if (!dropdown) return;

    item.addEventListener("mouseenter", () => {
      if (!DESKTOP.matches) return;
      openItem(item);
    });

    item.addEventListener("mouseleave", () => {
      if (!DESKTOP.matches) return;
      scheduleClose(item);
    });

    dropdown.addEventListener("mouseenter", () => {
      if (!DESKTOP.matches) return;
      openItem(item);
    });

    dropdown.addEventListener("mouseleave", () => {
      if (!DESKTOP.matches) return;
      scheduleClose(item);
    });

    item.addEventListener("focusin", () => {
      if (!DESKTOP.matches) return;
      openItem(item);
    });

    item.addEventListener("focusout", () => {
      if (!DESKTOP.matches) return;
      scheduleClose(item);
    });
  }

  function bootMegaHoverHold() {
    document
      .querySelectorAll(
        'sticky-header .header-navigation .menu-lv-item.has-megamenu, sticky-header .header-navigation .menu-lv-item.dropdown'
      )
      .forEach(bindItem);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootMegaHoverHold);
  } else {
    bootMegaHoverHold();
  }

  document.addEventListener("shopify:section:load", bootMegaHoverHold);
})();